import { render, staticRenderFns } from "./InputDatePicker.vue?vue&type=template&id=b654bad0&scoped=true"
import script from "./InputDatePicker.vue?vue&type=script&lang=ts"
export * from "./InputDatePicker.vue?vue&type=script&lang=ts"
import style0 from "./InputDatePicker.vue?vue&type=style&index=0&id=b654bad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b654bad0",
  null
  
)

export default component.exports